import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Showreel: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const videoElement = document.querySelector("video");
    if (videoElement) {
      videoElement.muted = true; // Ensure the video is muted for autoplay to work
    }
  }, []);

  return (
    <div className="fixed top-0 left-0 w-full h-screen text-white overflow-hidden z-0">
      <div className="w-full h-full relative">
        <video
          className="absolute inset-0 w-full h-full object-cover z-0 "
          src="30fps_draft.mp4"
          autoPlay
          loop
          muted
          playsInline
        />
      </div>
    </div>
  );
};

export default Showreel;
